export const images = {
  userIcon: "/icons/user.svg",
  cartIcon: "/icons/cart.svg",
  searchIcon: "/icons/search.svg",
  menuIcon: "/icons/menu.svg",
  logo: "/images/logo.png",
  integrity: "/icons/integrity_icon.png",
  barChart: "/icons/bar_icon.png",
  humanIcon: "/icons/human_icon.png",
  squareIcon: "/icons/square_icon.png",
  headPhoneIcon: "/icons/head_phones_icon.png",
  mapIcon: "/icons/map_icon.png",
  educationIcon: "/icons/capacitation_icon.png",
  lockedIcon: "/icons/locked_icon.png",
  starIcon: "/icons/star_icon.png",
  whatsApp: "/whatsapp_icon.png",
  whatsapp: "/whatsapp_icon.png",
  barnerAsesoria: "/barner_asesoria.png",
};
